import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/vip.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-622a50be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "VipWindow" }
const _hoisted_2 = { class: "VipImageDiv" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"40px"}
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "尊享永久会员", -1))

import { openVipUsingPost } from "@/request/api/userController";
import message from "@arco-design/web-vue/es/message";


export default /*#__PURE__*/_defineComponent({
  __name: 'VipWindow',
  setup(__props) {

const openVip = () => {
  openVipUsingPost().then((res) => {
    if (res.data.code == 0) {
      if (res.data.data) {
        message.success("开通成功");
      } else {
        message.success("已经开通过了");
      }
    } else {
      message.error("开通失败");
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_typography_text, {
            type: "secondary",
            style: {"color":"#9f9f9f"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 解锁所有面试题解，一次性买断 ")
            ]),
            _: 1
          }),
          _createVNode(_component_a_typography_text, {
            type: "secondary",
            style: {"color":"#9f9f9f"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 使用AI生成题目和AI智能判题 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_space, { style: {"margin-top":"-10px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_typography_title, {
            bold: "",
            style: {"color":"#fcefc2"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费 ")
            ]),
            _: 1
          }),
          _createVNode(_component_a_badge, {
            text: "限时优惠",
            style: {"margin-top":"-20px","position":"absolute"}
          }),
          _createVNode(_component_a_typography_text, { style: {"padding-top":"32px","color":"#9f9f9f"} }, {
            default: _withCtx(() => [
              _createTextVNode(" /永久 ")
            ]),
            _: 1
          }),
          _createVNode(_component_a_typography_text, {
            style: {"padding-top":"32px","color":"#9f9f9f"},
            delete: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" ¥99 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            shape: "round",
            size: "large",
            style: {"width":"300px","margin":"0 auto"},
            onClick: openVip
          }, {
            default: _withCtx(() => [
              _createTextVNode("立即开通 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, { style: {"margin-top":"10px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_typography_text, {
            type: "secondary",
            style: {"color":"#9f9f9f"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 开通前请先阅读 ")
            ]),
            _: 1
          }),
          _createVNode(_component_a_typography_text, { style: {"color":"#fcefc2"} }, {
            default: _withCtx(() => [
              _createTextVNode(" 《易答会员协议》 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})